// extracted by mini-css-extract-plugin
export default {"container":"Summary_container__nOXBu","row":"Summary_row__s3At-","label":"Summary_label__1RQp1","value":"Summary_value__TqRT8","listValue":"Summary_listValue__OTa9r"};